import * as React from 'react';

import { createClient, type Client } from '@connectrpc/connect';
import { ScannerLocalService } from '@rematter/frontend-lib-api-client/grpc/sidecar/v1/scanner_local_api_pb';

import { useLibp2p } from './useLibp2p';

export type ScannerLocalClient = Client<typeof ScannerLocalService>;

export function useScannerLocalClient(
  sidecarId: string,
): ScannerLocalClient | null {
  const { getTransport, connections } = useLibp2p();

  const isConnected = connections.get(sidecarId)?.connected ?? false;

  return React.useMemo(() => {
    if (!isConnected) return null;

    const transport = getTransport(sidecarId);
    if (!transport) return null;

    return createClient(ScannerLocalService, transport);
  }, [sidecarId, getTransport, isConnected]);
}
